var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRectangleButtonLeft = function SvgRectangleButtonLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.643,
    height: 107.957,
    viewBox: "0 0 87.643 107.957"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    d: "M43.656.1Q21.854,27.018,0,53.88c7.789,9.854,15.868,19.558,23.748,29.375,6.725,8.209,13.374,16.526,20.109,24.7C58.534,90.065,73.02,71.991,87.643,54.044c-2.018-3.076-4.743-5.836-6.971-8.83C68.349,30.17,56.153,15.007,43.8,0Z",
    transform: "translate(87.643 107.957) rotate(180)",
    fill: "#bfc9c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "arrow_2_",
    d: "M-930.072,921.086l-.808.808L-937,915.774l6.119-6.119.808.808-5.311,5.311,5.311,5.311Z",
    transform: "translate(977.357 -861.796)",
    fill: "#002238",
    fillRule: "evenodd"
  })));
};

export { SvgRectangleButtonLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfODQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9Ijg3LjY0MyIgaGVpZ2h0PSIxMDcuOTU3IiB2aWV3Qm94PSIwIDAgODcuNjQzIDEwNy45NTciPgogIDxwYXRoIGlkPSJVbmlvbl8xIiBkPSJNNDMuNjU2LjFRMjEuODU0LDI3LjAxOCwwLDUzLjg4YzcuNzg5LDkuODU0LDE1Ljg2OCwxOS41NTgsMjMuNzQ4LDI5LjM3NSw2LjcyNSw4LjIwOSwxMy4zNzQsMTYuNTI2LDIwLjEwOSwyNC43QzU4LjUzNCw5MC4wNjUsNzMuMDIsNzEuOTkxLDg3LjY0Myw1NC4wNDRjLTIuMDE4LTMuMDc2LTQuNzQzLTUuODM2LTYuOTcxLTguODNDNjguMzQ5LDMwLjE3LDU2LjE1MywxNS4wMDcsNDMuOCwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODcuNjQzIDEwNy45NTcpIHJvdGF0ZSgxODApIiBmaWxsPSIjYmZjOWM2Ii8+CiAgPHBhdGggaWQ9ImFycm93XzJfIiBkPSJNLTkzMC4wNzIsOTIxLjA4NmwtLjgwOC44MDhMLTkzNyw5MTUuNzc0bDYuMTE5LTYuMTE5LjgwOC44MDgtNS4zMTEsNS4zMTEsNS4zMTEsNS4zMTFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NzcuMzU3IC04NjEuNzk2KSIgZmlsbD0iIzAwMjIzOCIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";